import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { AuthTokenService } from 'src/app/Service/Auth/auth-token.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-UserList',
  templateUrl: './UserList.component.html',
  styleUrls: ['./UserList.component.scss']
})
export class UserListComponent implements OnInit {
  Filter_Name: string = ""
  Filter_Familly: string = ""
  Filter_Username: string = ""
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private User_Service: UserService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private loginService: LoginService,
    private authTokens: AuthTokenService,
    public router: Router,
    private modalService: BsModalService
  ) { }


  DataList_User: Array<User_Interface> = []
  Data_Seleted_Delete: User_Interface = Empty_User_Interface()

  ngOnInit() {

    this.Nav_Service.CheckValidPage(22).subscribe(
      data => {
        this.ReadData_User()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_User() {
    this.Procssing = true
    this.User_Service.GetRecord().subscribe(
      data => {
        this.DataList_User = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter() {
    this.page = 0
  }

  Delete(item: User_Interface) {
    item.DeletingProccess = true
    this.modalRef_Delete.hide()
    this.User_Service.DeleteUser(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_User()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  AutoLogin(item:User_Interface): void {

    this.Procssing = true
    this.loginService.AutoLogin(item.id).subscribe(
      response => {

        if (!response['accessToken']) {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("این حساب کاربری در سامانه ثبت ورود شده است و کاربر آن در وضیعت فعالیت می باشد.")
        }
        else {

          this.Alertify_Service.SuccessMessage(response['fullname'] + " خوش آمدید ")
          this.authTokens.storeLoginResponse(response);
          localStorage.setItem('Daro_User_UserImage', response['userImage']);
          localStorage.setItem('Daro_User_Fullname', response['fullname']);
          localStorage.setItem('Daro_User_Type', response['type']);
          localStorage.setItem('Daro_User_CanLetterHistory', response['canLetterHistory']);

          var Menu: Array<Nav_Interface> = response['menu_user']
          localStorage.setItem('Daro_User_Nav', JSON.stringify(Menu));

          this.router.navigate(['/Dashboard']);
          this.ReadData_Loging_KeySearch()
        }

      }
    )
  }




  ReadData_Loging_KeySearch_Timer: any
  ReadData_Loging_KeySearch() {

    if (this.ReadData_Loging_KeySearch_Timer) {
      clearTimeout(this.ReadData_Loging_KeySearch_Timer);
      this.ReadData_Loging_KeySearch_Timer = null;
    }

    this.ReadData_Loging_KeySearch_Timer = setTimeout(function () {
      this.LogingFunctionReload()
    }.bind(this), 1000);

  }

  LogingFunctionReload() {
    location.reload();
  }


}
